import { useEffect } from "react";
import { App } from "@capacitor/app";
import { isNativePlatform } from "@/lib/capacitor";
import { useNavigate } from "react-router-dom";

const PAYMENT_SCHEME_PREFIX = "com.muminsmart.app://payment/success";

export default function AppUrlHandler() {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isNativePlatform()) {
      return;
    }

    const handleUrl = (rawUrl: string) => {
      if (!rawUrl.startsWith(PAYMENT_SCHEME_PREFIX)) {
        return;
      }

      try {
        const url = new URL(rawUrl);
        const paymentAttemptId = url.searchParams.get("paymentAttemptId");
        const orderId = url.searchParams.get("orderId");

        if (!paymentAttemptId || !orderId) {
          return;
        }

        navigate(
          `/payment/success?paymentAttemptId=${encodeURIComponent(paymentAttemptId)}&orderId=${encodeURIComponent(orderId)}`,
          { replace: true },
        );
      } catch (error) {
        console.error("Failed to handle app URL", error);
      }
    };

    void App.getLaunchUrl().then((result) => {
      if (result?.url) {
        handleUrl(result.url);
      }
    });

    const listener = App.addListener("appUrlOpen", (event) => {
      handleUrl(event.url);
    });

    return () => {
      void listener.then((handle) => handle.remove());
    };
  }, [navigate]);

  return null;
}
